import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listAppRecommendationsByBusinessInsightRequest = {};
var _listAppRecommendationsByBusinessInsightResponse = {};
var _listAppRecommendationsByBusinessTermIdRequest = {};
var _listAppRecommendationsRequest = {};
var _listAppRecommendationsResponse = {};
function resolveWixFunnelAppRecommendationV1AppRecommendationServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-app-recommendation-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-app-recommendation-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/funnel-app-recommendation-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/funnel-app-recommendation-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/funnel-app-recommendation-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get list of recommended apps */
export function listAppRecommendations(payload) {
    var _a = serializer(_listAppRecommendationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppRecommendationsResponse, {}).fromJSON;
    function __listAppRecommendations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.app_recommendation.v1.app_recommendation',
            method: 'GET',
            methodFqn: 'wix.funnel.app_recommendation.v1.AppRecommendationService.ListAppRecommendations',
            url: resolveWixFunnelAppRecommendationV1AppRecommendationServiceUrl({
                protoPath: '/v1/app-recommendation/recommend',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppRecommendations.fromReq = fromReq;
    return __listAppRecommendations;
}
/** Get list of recommended apps */
export function listAppRecommendationsByBusinessTermId(payload) {
    var _a = serializer(_listAppRecommendationsByBusinessTermIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppRecommendationsResponse, {}).fromJSON;
    function __listAppRecommendationsByBusinessTermId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.app_recommendation.v1.app_recommendation',
            method: 'GET',
            methodFqn: 'wix.funnel.app_recommendation.v1.AppRecommendationService.ListAppRecommendationsByBusinessTermId',
            url: resolveWixFunnelAppRecommendationV1AppRecommendationServiceUrl({
                protoPath: '/v1/app-recommendation/recommend-by-business-term-id',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppRecommendationsByBusinessTermId.fromReq = fromReq;
    return __listAppRecommendationsByBusinessTermId;
}
/** Get list of recommended apps */
export function listAppRecommendationsByBusinessInsight(payload) {
    var _a = serializer(_listAppRecommendationsByBusinessInsightRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppRecommendationsByBusinessInsightResponse, {}).fromJSON;
    function __listAppRecommendationsByBusinessInsight(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.app_recommendation.v1.app_recommendation',
            method: 'GET',
            methodFqn: 'wix.funnel.app_recommendation.v1.AppRecommendationService.ListAppRecommendationsByBusinessInsight',
            url: resolveWixFunnelAppRecommendationV1AppRecommendationServiceUrl({
                protoPath: '/v1/app-recommendation/recommend-by-business-insight',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppRecommendationsByBusinessInsight.fromReq = fromReq;
    return __listAppRecommendationsByBusinessInsight;
}
//# sourceMappingURL=http.impl.js.map